import React from "react";
import { Card, Col, Row, Switch } from "antd";
import "../../index.css";

const WidgetStatus = ({ widget, handleWidgetChange }) => {
  const handleStatusChange = (value) => {
    handleWidgetChange({ status: value, id: widget.id });
  };

  return (
    <Card className="setting_wrapper">
      <Row className="">
        <Col span={20}>
          <h4>Widget Status</h4>
        </Col>
        <Col span={4}>
          <div className="switch">
            <Switch
              name="status"
              id="custom-switch"
              onChange={handleStatusChange}
              defaultChecked={widget?.status}
              checked={widget?.status}
            />
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default WidgetStatus;
